
import { KeyFacet, stringPart } from '../KeyFacet';

export const imageByUrlKeyFacet = new KeyFacet<{
  url: string;
}>('imageByUrl', {
  url: stringPart()
});
